export class PasswordChangeRequest {
  public currentPassword: string = ''
  public newPassword: string = ''
}
